<div class="container-fluid mb-2 px-4">
    <mat-card class="mt-3 pb-5">
        <div class="row justify-content-center">
            <div class="col-12">
                <app-data-table 
                    [component]="'Policy Underwriters'"
                    [dataSource]="dataSource" 
                    [displayedColumns]="displayedColumns" 
                    [displayLoadingIndicator]="loading"
                    [navigateOnRowClick]="false"
                    (editPolicyUnderwriterClickedEvent)="onEditUnderwriterActionClick($event)"
                    (deletePolicyUnderwriterClickedEvent)="onDeleteUnderwriterActionClick($event)"
                    [showSearch]="false"
                    [showPaginator]="false"
                    (actionClickedEvent)="onViewRangesOpenClick($event)">
                </app-data-table>
            </div>
        </div>
    </mat-card>
</div>